import axios from "axios";
import { requestFailure, requestSuccess } from "./axios.utils";

const BASE_URL = `${import.meta.env.VITE_BASE_URL}/api`;

// Accounts Instance
export const AXIOS = axios.create({ baseURL: BASE_URL });

AXIOS.interceptors.request.use(
  (config) => requestSuccess(config),
  requestFailure
);
AXIOS.interceptors.response.use((config) => config, requestFailure);

export default AXIOS;
